"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoryProps = exports.getCategoryData = exports.getCategoryKeyWithGeo = void 0;
var getCategoryKeyWithGeo = function (_a) {
    var category = _a.category, gamesByCategories = _a.gamesByCategories, countryCode = _a.countryCode;
    if (!category)
        return category !== null && category !== void 0 ? category : undefined;
    var geoCategoryKey = countryCode && category
        ? "".concat(category, "_").concat(countryCode.toLowerCase())
        : undefined;
    if (geoCategoryKey && (gamesByCategories === null || gamesByCategories === void 0 ? void 0 : gamesByCategories[geoCategoryKey])) {
        return geoCategoryKey;
    }
    return category;
};
exports.getCategoryKeyWithGeo = getCategoryKeyWithGeo;
var getCategoryData = function (_a) {
    var category = _a.category, gamesByCategories = _a.gamesByCategories, countryCode = _a.countryCode;
    var categoryKey = (0, exports.getCategoryKeyWithGeo)({
        category: category,
        gamesByCategories: gamesByCategories,
        countryCode: countryCode,
    });
    return categoryKey ? gamesByCategories === null || gamesByCategories === void 0 ? void 0 : gamesByCategories[categoryKey] : undefined;
};
exports.getCategoryData = getCategoryData;
var getCategoryProps = function (params) {
    var categoryData = (0, exports.getCategoryData)(params);
    return {
        games: (categoryData === null || categoryData === void 0 ? void 0 : categoryData.previewGames) || [],
        title: (categoryData === null || categoryData === void 0 ? void 0 : categoryData.title) || '',
        category: (categoryData === null || categoryData === void 0 ? void 0 : categoryData.slug) || '',
    };
};
exports.getCategoryProps = getCategoryProps;
